import React, { Suspense } from 'react';

import { useDebugBarData } from 'hooks/useDebugBar';

import Portal from 'utility/Bind/Portal/Portal';

import { DEVICED_DEBUGBAR_TARGET_ID } from './__config/constants';

const LazyDevicedDebugBarEntry = React.lazy(
    () => import('./__partial/DebugBar')
);

export default function DevicedDebugBarEntry() {
    const debugBarData = useDebugBarData();

    return (
        <Portal root={DEVICED_DEBUGBAR_TARGET_ID}>
            <Suspense fallback={<></>}>
                <LazyDevicedDebugBarEntry debugBarEntryList={debugBarData} />
            </Suspense>
        </Portal>
    );
}
